// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxField_wrapper__hBwiw","input":"CheckboxField_input__EVBBa","label":"CheckboxField_label__-rNS+"};